function createCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}

function readCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
  }
  return null;
}

export function initCookieConsent() {
  const notice = document.getElementById('cookie-notice');
  const accept = document.getElementById('cookie-notice-accept');
  if (!notice || !accept) return;

  const cookieName = 'cookie-notice-dismissed';

  if (readCookie(cookieName) === 'true') {
    notice.style.display = 'none';
    return;
  }

  notice.style.display = 'block';
  accept.addEventListener('click', function() {
    createCookie(cookieName, 'true', 31);
    notice.style.display = 'none';
  });
}
